import { AppConfigModel } from "../abstract/app-config.model";

export class InvoiceNumbering extends AppConfigModel {

    static override CLASS_NAME: string = 'InvoiceNumbering';
}
